import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { tenantActions } from '../openFlowRedux/tenant.actions';
import { MainSection } from '../style';
import BackGroundGenerator from '../../LandingPages/common/BackGroundGenerator';
import CheckOutBox from '../../../../openbrix-design-system/ui/molecules/openflowHome/CheckOutBox';
import moment from 'moment';

const CheckOut = (props) => {
  const dispatch = useDispatch();
  const [moveOutData, setMoveOutData] = useState(null);

  const reduxMoveOutData = useSelector((state) => state?.tenant?.moveOutData);
  const flowId = props?.route?.params?.id || (typeof window !== 'undefined' && window.location?.pathname?.split('/')?.pop());

  useEffect(() => {
    if (flowId) {
      fetchMoveOutData();
    }
  }, [flowId]);

  useEffect(() => {
    if (reduxMoveOutData) {
      setMoveOutData(reduxMoveOutData);
    }
  }, [reduxMoveOutData]);

  const fetchMoveOutData = () => {
    if (!flowId) return;
    dispatch(
      tenantActions.getMoveOutData(flowId, (data) => {
        setMoveOutData(data);
      })
    );
  };

  const handleSaveMeterReadings = (payload, callback) => {
    if (!flowId) return;
    dispatch(
      tenantActions.saveMeterReadings(flowId, payload, (res) => {
        fetchMoveOutData();
        if (callback && typeof callback === 'function') {
          callback(res);
        }
      })
    );
  };

  const resolvedData = moveOutData?.data || moveOutData || reduxMoveOutData?.data || reduxMoveOutData;
  const checkoutObj = resolvedData?.open_flow_move_out_checkout;
  const hasMeterReadings = Array.isArray(resolvedData?.open_flow_move_out_meter_readings) && resolvedData.open_flow_move_out_meter_readings.length > 0;
  const hasInventoryDocs = Array.isArray(resolvedData?.open_flow_move_out_inventory_documents) && resolvedData.open_flow_move_out_inventory_documents.length > 0;
  const isCheckoutCompleted = checkoutObj ? (checkoutObj.is_completed || (hasMeterReadings && hasInventoryDocs)) : false;
  const buttonTextVal = checkoutObj ? (isCheckoutCompleted ? 1 : 4) : 0;

  const checkoutDesc = checkoutObj?.checkout_date 
    ? `Your checkout is scheduled for ${moment(checkoutObj.checkout_date).format('DD/MM/YYYY')} at ${checkoutObj.checkout_time || ''}.`
    : 'Details of your check out may be found here together with an End of Tenancy Guide.';

  return (
    <BackGroundGenerator
      props={props}
      isTLYF
      isOpenflowContainer
      openFlowData={{
        title: 'Check Out',
        desc: checkoutDesc,
        buttonText: buttonTextVal,
        message: '',
        listIcon: 'rentaloffer',
        iconColor: '#A070C4',
      }}
    >
      <MainSection>
        <CheckOutBox
          data={moveOutData || reduxMoveOutData}
          onSaveMeterReadings={handleSaveMeterReadings}
        />
      </MainSection>
    </BackGroundGenerator>
  );
};

const styles = StyleSheet.create({});
export default CheckOut;
